import { Link } from "react-router-dom"
import { translate } from "../app"
import { translations } from "../translations"

interface Props {
  isRtl: boolean
  items: {
    link?: string
    title: string
  }[]
}

export function Breadcrumb(props: Props) {
  return <nav aria-label={translate(translations.breadcrumb)}>
    <ol className={`flex gap-2 text-sm text-gray-400 list-none p-0 m-0 !justify-start ${props.isRtl ? 'flex-row-reverse' : ''}`}>
      {props.items.map((item, index) => {
        const isLast = index === props.items.length - 1
        return <li key={index} className="flex gap-2 items-center">
          {item.link && !isLast
            ? <Link className="text-gray-400 underline" to={item.link}>{item.title}</Link>
            : <span className="text-black text-sm" aria-current={isLast ? "page" : undefined}>{item.title}</span>}
          {!isLast && <span className="text-gray-400" aria-hidden="true">{">"}</span>}
        </li>
      })}
    </ol>
  </nav>
}
